import { render, staticRenderFns } from "./DownMessage.vue?vue&type=template&id=a3f58518&scoped=true&"
import script from "./DownMessage.vue?vue&type=script&lang=js&"
export * from "./DownMessage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a3f58518",
  null
  
)

export default component.exports